import React, { useState } from 'react';
import { TextField, MuiThemeProvider } from '@material-ui/core';
import PropTypes from 'prop-types';
import toastr from 'toastr';
import materialTheme from '../../reactMaterialTheme';

import 'react-tabs/style/react-tabs.css';

const DynamicNativeBuilder = props => {
  return (
    <MuiThemeProvider theme={materialTheme}>
      <DynamicNativeForm {...props} />
    </MuiThemeProvider>
  );
};

const DynamicNativeForm = props => {
  const {
    DcoAssetsService,
    CreativeService
  } = props;

  const [name, setName] = useState(CreativeService.creative.name || '');
  const [dcoUrl, setDcoUrl] = useState(CreativeService.creative.dcoUrl || '');

  const fetchDcoAssets = () => {
    return DcoAssetsService.fetch(dcoUrl)
      .then(responseCreative => {
        const creative = Object.assign(CreativeService.creative, responseCreative);
        CreativeService.setCreative(creative);
      })
      .catch(() => {
        toastr.error('Failed to fetch DCO assets');
      });
  };

  const onChange = (event, value) => {
    const fieldName = event.target.name;
    const fieldValue = value === undefined ? event.target.value : value;
    const { creative } = CreativeService;

    if (fieldName === 'name') {
      setName(fieldValue);
      CreativeService.setCreative({ ...creative, name: fieldValue});
    } else {
      setDcoUrl(fieldValue);
      CreativeService.setCreative({ ...creative, dcoUrl: fieldValue});
    }
  };

  return (
    <MuiThemeProvider theme={materialTheme}>
      <form className="p2">
        <div className="row">
          <div className="col-xs-12">
            <TextField
              label="Ad Name"
              className="col-xs-10"
              name="name"
              value={name}
              onChange={onChange}
              inputProps={{"data-testid": "dynamic-native-name"}}
              required
            />
          </div>
        </div>
        <div className="row mt2 mb2">
          <div className="col-xs-12">
            <div className="col-xs-7 no-gutters">
              <TextField
                label="DCO URL"
                className="media-url-field"
                name="dcoUrl"
                value={dcoUrl}
                onChange={onChange}
                inputProps={{"data-testid": "dynamic-native-dco-url"}}
                required
              />
            </div>
            <div className="col-xs-2 pt2 pl0 ml3">
              <button
                aria-label="Pull Content"
                className="btn btn-secondary"
                data-testid="dynamic-native-pull-content"
                onClick={fetchDcoAssets}
                type="button"
              >
                Pull Content
              </button>
            </div>
          </div>
        </div>
      </form>
    </MuiThemeProvider>
  );
};

DynamicNativeBuilder.propTypes = {
  CreativeService: PropTypes.object.isRequired,
  DcoAssetsService: PropTypes.object.isRequired
};

DynamicNativeForm.propTypes = {
  ...DynamicNativeBuilder.propTypes
};

export default DynamicNativeBuilder;
